export default "__VITE_ASSET__KwWhopR6__"